<template>
  <div>
    <b-modal
      v-model="dialog"
      centered
      size="md"
      button-size="sm"
      no-close-on-backdrop
    >
      <template #modal-header>
        <h5 class="modal-title">Add Event to Dashboard</h5>
        <button type="button" class="close" @click="close()">×</button>
      </template>
      <b-alert v-model="hasError" variant="danger" fade>
        {{ errorMessage }}
      </b-alert>
      <b-alert v-model="success" variant="success" fade>
        {{ successMessage }}
      </b-alert>

      <div>
        <dx-text-box
          label-mode="floating"
          label="Search by ID or Eventlisttitle (DE / EN)"
          class="mt-3"
          :show-clear-button="true"
          :onValueChanged="changeEventSearch"
        />
        <dx-select-box
          v-if="events"
          :data-source="events"
          label-mode="floating"
          label="Select Event"
          v-model="form.eventId"
          :search-enabled="true"
          value-expr="field_001"
          display-expr="combinedField"
          class="mt-3"
          :showDataBeforeSearch="true"
          :onValueChanged="selectEvent"
        />
        <form @submit.prevent="onSubmit">
          <dx-number-box
            label-mode="floating"
            label="Minimum Registrations"
            v-model="form.minReg"
            class="mt-3"
            :disabled="!form.eventId"
          />
          <dx-number-box
            label-mode="floating"
            label="Minimum Confirmed"
            v-model="form.minConf"
            class="mt-3"
            :disabled="!form.eventId"
          />
          <dx-number-box
            label-mode="floating"
            label="Minimum Doc Submitted"
            v-model="form.minDocSubmitted"
            class="mt-3"
            :disabled="!form.eventId"
          />
          <dx-tag-box
            :data-source="vlamsUsers"
            label-mode="floating"
            label="Select Owners"
            value-expr="mitarbeiterId"
            display-expr="combinedField"
            v-model="owners"
            :search-enabled="true"
            class="mt-3"
            :disabled="!form.eventId"
          />
          <dx-button
            text="Save and Add to Dashboard"
            type="success"
            class="mt-4"
            :disabled="!form.eventId"
            :use-submit-behavior="true" />
        </form>
      </div>

      <template #modal-footer>
        <div class="w-100">
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  // import { ValidationObserver, ValidationProvider } from 'vee-validate'
  import { errorHandler } from '@/helpers/formHelper.js'
  import DxSelectBox from 'devextreme-vue/select-box'
  import { DxTextBox } from 'devextreme-vue/text-box'
  import { DxTagBox } from 'devextreme-vue/tag-box'
  import DxButton from 'devextreme-vue/button'
  import { DxNumberBox } from 'devextreme-vue/number-box'

  const getInitialData = () => ({
    form: {
      eventId: null,
      minReg: null,
      minConf: null,
      minDocSubmitted: null
    }
  })

  export default {
    name: 'add-event-modal',
    components: {
      DxSelectBox,
      DxTextBox,
      DxTagBox,
      DxButton,
      DxNumberBox
    },
    data () {
      return {
        dialog: false,
        hasError: false,
        errorMessage: '',
        success: false,
        successMessage: '',
        ...getInitialData(),
        owners: []
      }
    },
    created () {
      this.getVlamsUsers()
    },
    methods: {
      onSubmit () {
        this.hasError = false
        const formData = this.form
        this.addToDashboard(formData)
      },
      addToDashboard (formData) {
        const alreadyExists = this.checkExistingEvent(formData.eventId)
        if (!alreadyExists) {
          this.$store.dispatch('eventDashboard/CREATE_EVENT_OWNER', formData.eventId).then(res => {
            const { errors } = res
            if (errors) {
              return errorHandler(this, errors)
            } else {
              this.handleOwners(formData)
              this.updateEvent(formData)
            }
          }).catch(err => {
            this.hasError = true
            this.errorMessage = this.$t('formError.unknownwError')
            console.error(err)
            setTimeout(() => {
              this.hasError = false
            }, 3000)
          })
        } else {
          this.handleOwners(formData)
          this.updateEvent(formData)
        }
      },
      updateEvent (formData) {
        this.$store.dispatch('eventDashboard/UPDATE_EVENT', formData).then(res => {
          const { errors } = res
          if (errors) {
            return errorHandler(this, errors)
          } else {
            this.success = true
            this.successMessage = 'Event successfully edited/added to your dashboard'
            this.$emit('added-event')
            setTimeout(() => {
              this.success = false
              this.reset()
            }, 2000)
          }
        }).catch(err => {
          this.hasError = true
          this.errorMessage = this.$t('formError.unknownwError')
          console.error(err)
          setTimeout(() => {
            this.hasError = false
          }, 3000)
        })
      },
      selectEvent (e) {
        if (e.value !== null && e.value !== 0) {
          this.$store.dispatch('eventDashboard/GET_EVENT', e.value).then(res => {
            const data = res
            if (data.errors) {
              return errorHandler(this, data.errors)
            } else {
              this.form.eventId = data.field_001
              this.form.minReg = data.min_registrations
              this.form.minConf = data.min_confirmed
              this.form.minDocSubmitted = data.min_doc_submitted
              this.getOwnersByEventId(data.field_001)
            }
          }).catch(err => {
            this.hasError = true
            this.errorMessage = this.$t('formError.unknownwError')
            console.error(err)
            setTimeout(() => {
              this.hasError = false
            }, 3000)
          })
        }
      },
      handleOwners (formData) {
        if (this.owners.length > 0) {
          for (const el in this.owners) {
            const alreadyExists = this.ownersByEventId.find(element => element.userId === this.owners[el])
            if (!alreadyExists && this.owners[el] !== this.currentUser.mitarbeiterId) {
              const newFormData = {
                eventId: formData.eventId,
                userId: this.owners[el]
              }
              this.createOtherOwners(newFormData)
            }
          }
        }
        if (this.ownersByEventId.length > 0) {
          for (const el in this.ownersByEventId) {
            const stillExists = this.owners.find(element => element === this.ownersByEventId[el].userId)
            if (!stillExists) {
              this.removeOwner(this.ownersByEventId[el].field_001)
            }
          }
        }
      },
      createOtherOwners (formData) {
        this.$store.dispatch('eventDashboard/CREATE_EVENT_OTHER_OWNER', formData).then(res => {
          const { errors } = res
          if (errors) {
            return errorHandler(this, errors)
          }
        }).catch(err => {
          this.hasError = true
          this.errorMessage = this.$t('formError.unknownwError')
          console.error(err)
          setTimeout(() => {
            this.hasError = false
          }, 3000)
        })
      },
      checkExistingEvent (addingEventId) {
        const alreadyExists = this.dashboardevents.find(x => x.eventId === addingEventId)
        return alreadyExists
      },
      openModal () {
        this.dialog = true
      },
      close () {
        this.dialog = false
        this.reset()
      },
      changeEventSearch (e) {
        this.reset()
        if (e.value !== '' && e.value !== null) {
          this.getEvents(e.value)
        }
      },
      reset () {
        Object.assign(this.$data, getInitialData())
        this.owners = []
      },
      async getEvents (searchValue) {
        this.hasError = false
        try {
          await this.$store.dispatch('eventDashboard/GET_EVENTS', searchValue)
        } catch (err) {
          this.hasError = true
          console.error(err)
        }
      },
      async getVlamsUsers () {
        this.hasError = false
        try {
          const { errors } = await this.$store.dispatch('user/GET_USERS_AND_ROLES')
          if (errors) throw errors
        } catch (err) {
          this.hasError = true
          console.error(err)
        }
      },
      async getOwnersByEventId (eventId) {
        this.hasError = false
        try {
          const { errors } = await this.$store.dispatch('eventDashboard/GET_OWNERS_BY_EVENTID', eventId)
          if (errors) throw errors
          const ownersArray = []
          for (const owner of this.ownersByEventId) {
            ownersArray.push(owner.userId)
          }
          this.owners = ownersArray
        } catch (err) {
          this.hasError = true
          console.error(err)
        }
      },
      async removeOwner (itemToRemove) {
        this.hasError = false
        try {
          const { errors } = await this.$store.dispatch('eventDashboard/DELETE_OWNER', itemToRemove)
          if (errors) throw errors
          setTimeout(() => {
            this.success = false
          }, 3000)
        } catch (err) {
          this.hasError = true
          this.errorMessage = this.$t('formError.unknownwError')
          console.error(err)
        }
      }
    },
    computed: {
      ...mapGetters({
        events: 'eventDashboard/EVENTS',
        dashboardevents: 'eventDashboard/DASHBOARDEVENTS',
        vlamsUsers: 'user/VLAMS_USERS',
        ownersByEventId: 'eventDashboard/OWNERSBYEVENTID'
      }),
      ...mapState({
        currentUser: state => state.user.currentUser
      })
    }
  }
</script>
